import { useStoreActions, useStoreState } from '@/store'
import AgentRow from './AgentRow'
import { Agent } from '@/types/agents'
import { agentsPerPage } from '@/store/models/search'
import generics from '@/utils/generics'
import { useEffect } from 'react'
import Icon from '../elements/Icon'

type SearchProps = {
  results: Agent[]
  total: number
}

const SearchResults = ({ results, total }: SearchProps) => {
  const { queryResponse, isSearching, displayCount, embedded } = useStoreState(
    state => state.search
  )

  const primaryLocation = useStoreState(state => state.search.primaryLocation)

  const { setLimit, triggerSearch, setDisplayCount, setIsSearching } =
    useStoreActions(actions => actions.search)
  const { onProductListViewedTracking, onElementClickedTracking, resetEvents } =
    useStoreActions(actions => actions.tracking)

  useEffect(() => {
    const initalProductListViewedPayload =
      generics.buildProductListViewedPayload(results)

    onProductListViewedTracking(initalProductListViewedPayload)
  }, [queryResponse])

  const onViewMore = () => {
    const newDisplayCount = displayCount + agentsPerPage

    setIsSearching(1)
    setLimit(newDisplayCount)
    setDisplayCount(newDisplayCount)
    triggerSearch()

    const elementClickedPayload = generics.buildElementClickedPayload(
      'button',
      'agent table',
      'bottom',
      'view more',
      'View more',
      'show 8 more results'
    )
    onElementClickedTracking(elementClickedPayload)
  }

  return (
    <>
      {results.map((result, index) => (
        <AgentRow
          agent={result}
          location={primaryLocation}
          index={index}
          key={result.id}
        />
      ))}

      <p className="text-gray-700 text-xs my-7">
        Powered by BR Tech Services
        {embedded && (
          <>
            {' '}
            in partnership with{' '}
            <Icon
              variant="homelight"
              className="relative"
              style={{ top: '6px' }}
            />
          </>
        )}
      </p>

      {total > results.length && (
        <div className="mx-auto text-center my-10">
          <button
            className={`Button Button--secondary w-1/3 px-0 ${
              isSearching ? 'is-loading' : ''
            }`}
            onClick={onViewMore}
            data-testid="view-more-btn"
          >
            View more
          </button>
        </div>
      )}
    </>
  )
}

export default SearchResults
